 
import { useQuery } from '@tanstack/react-query';
import { supabase } from '../../api';

const getServiceDone = async (idUser: string, idService: string) => {
  const { count, error } = await supabase
    .from('booking_transactions')
    .select('id', { count: 'exact', head: true })  
    .eq('user_id', idUser)
    .eq('service', idService)
    .eq('status', 'Completed');

  if (error) throw new Error(error.message);
  return (count ?? 0) > 0;  
};
   

export default function useGetServiceFinishedByUserAndServiceId(
  idUser?: string,
  idService?: string
) {
  return useQuery({
    queryKey: ['useGetServiceFinishedByUserAndServiceId', idUser, idService],
    queryFn: () => getServiceDone(idUser!, idService!),  
    staleTime: 0,
    enabled: !!idUser && !!idService, 
  });
}